<template>
  <article class="transaction-about card">
    <header class="card__header">
      <h1 class="card__title">Sobre o {{ coin.title }}</h1>
    </header>

    <a href="https://google.com.br" target="_blank" class="card__body">
      <div class="transaction-about__header">
        <Icon class="transaction-about__icon" :icon="coin.title" />

        <span
          :style="style"
          v-text="coin.initial"
          class="transaction-about__initial"
          >
        </span>
      </div>

      <p class="transaction-about__content">Bitcoin usa a tecnologia ponto-a-ponto para operar sem a necessidade de uma autoridade central ou banco; as transações com bitcoins são gerenciadas coletivamente pelos usuários da rede.O Bitcoin é código aberto, seu design é público, ninguém é proprietário ou controla o Bitcoin e qualquer um pode participar. Através das suas várias e únicas características, a rede Bitcoin permite usos interessantes indisponíveis nos sistemas de pagamento anteriores.</p>

      <footer class="transaction-about__footer">
        <nav>
          <ul class="transaction-about__links">
            <li :key="label" v-for="label in links">
              <a class="transaction-about__link" href="#" v-text="label"></a>
            </li>
          </ul>
        </nav>
      </footer>
    </a>
  </article>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Icon from '@/components/Icon';

  export default {
    components: {
      Icon,
    },

    computed: {
      ...mapGetters('coins', [
        'coin',
      ]),

      links () {
        return [
          'Livro oficial', 'Site oficial',
        ];
      },

      style () {
        return {
          color: this.coin.color,
        };
      },
    },
  };
</script>

<style lang="scss">
  .transaction-about {
    &.card {
      display: flex;
      flex-direction: column;
    }

    .card__body {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    &__header {
      display: flex;
      align-items: center;
    }

    &__icon {
      width: 33px;
      height: 36px;
    }

    &__initial {
      margin-left: 8px;
      font-weight: 500;
      line-height: 0.88;
    }

    &__content {
      opacity: 0.8;
      color: #ffffff;
      margin: 36px 0;
      letter-spacing: 0.32px;
    }

    &__links {
      display: flex;
    }

    &__link {
      padding: 8px;
      font-size: 13px;
      color: #ffffff;
      border-radius: 4px;
      margin-right: 16px;
      letter-spacing: 0.26px;

      &:hover {
        background-color: rgba(#FFF, .1);
      }
    }
  }
</style>
